
import { toast } from 'sonner';
import { Session } from '@supabase/supabase-js';
import { processWaitlistSubmission, processNursingHomeLeads } from '@/utils/waitlist-processor';

export function useWaitlistProcessor() {
  const processStoredWaitlistData = async (session: Session) => {
    const formData = sessionStorage.getItem('waitlistFormData');
    
    if (!formData || !session?.user) return;

    try {
      const parsedData = JSON.parse(formData);
      
      // Get parameters for nursing home data
      const urlParams = new URLSearchParams(window.location.search);
      const nursingHomeName = urlParams.get('nursing_home') || parsedData.specificNursingHome;
      const countyName = urlParams.get('county');
      const nursingHomeSlug = urlParams.get('nh_slug');
      
      // Create waitlist submission
      await processWaitlistSubmission(session.user.id, parsedData);
      console.log("Waitlist submission successfully processed");
      
      // Process nursing home leads if applicable
      if (nursingHomeName || nursingHomeSlug || parsedData.preferredLocation?.length > 0) {
        await processNursingHomeLeads(
          session.user.id,
          parsedData,
          nursingHomeName,
          nursingHomeSlug,
          countyName
        );
        console.log("Nursing home leads successfully processed");
      }
      
      // Clear stored data
      sessionStorage.removeItem('waitlistFormData');
      
      toast.success("Your waitlist registration is complete!", {
        description: "View your dashboard to see your nursing home leads"
      });
      
      // Set a flag that we've just processed waitlist data after verification
      sessionStorage.setItem('justVerified', 'true');
      
      // Redirect to dashboard instead of using navigate
      // This ensures a clean state and avoids router context issues
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1500);
    } catch (e) {
      console.error("Error processing waitlist data:", e);
      toast.error("Could not process all your waitlist data", {
        description: "Please check your dashboard and try again if needed."
      });
    }
  };

  return { processStoredWaitlistData };
}
